import { FeatureFlagApi } from '../apis/featureFlagApi';
import { LoansApi } from '../apis/loansApi';
import { FeatureFlagEnum } from '../models/dtos/enums';
import { OutstandingLoanBalanceDto } from '../models/dtos/loan';

export interface WidgetDataResult {
  creditLineFlag?: boolean;
  outstandingLoanBalance?: OutstandingLoanBalanceDto;
}

export class WidgetService {
  async fetchFeatureFlag(
    featureFlagApi: FeatureFlagApi,
    flag: FeatureFlagEnum
  ): Promise<boolean> {
    try {
      const featureFlag = await featureFlagApi.getFeatureFlag(flag);
      return featureFlag.keyValue !== null && featureFlag.keyValue !== undefined
        ? featureFlag.keyValue
        : false;
    } catch (error) {
      throw error;
    }
  }

  async fetchOutstandingLoanBalance(
    loansApi: LoansApi
  ): Promise<OutstandingLoanBalanceDto> {
    try {
      return await loansApi.getOutstandingLoanBalance();
    } catch (error) {
      throw error;
    }
  }

  async fetchWidgetInitData(featureFlagApi: FeatureFlagApi): Promise<WidgetDataResult> {
    const result: WidgetDataResult = {};

    try {
      result.creditLineFlag = await this.fetchFeatureFlag(
        featureFlagApi,
        FeatureFlagEnum.InstaCashCreditLine
      );
    } catch (error) {
      result.creditLineFlag = false;
    }

    return result;
  }

  async fetchOutstandingWidgetData(loansApi: LoansApi): Promise<WidgetDataResult> {
    const result: WidgetDataResult = {};

    try {
      result.outstandingLoanBalance = await this.fetchOutstandingLoanBalance(loansApi);
    } catch (error) {
      throw error;
    }

    return result;
  }
}
